var _circle, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path4, _path5, _ellipse, _ellipse2, _g, _ellipse3, _path6, _path7, _path8, _path9, _rect33, _path10, _rect34, _path11, _path12, _path13, _path14, _path15, _g2, _rect35, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect36, _path28, _rect37, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _circle2, _path38, _circle3, _circle4, _circle5, _circle6, _circle7, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseNohandHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 330,
    viewBox: "0 0 529 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 300,
    r: 300,
    fill: "#E9F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.185 326.167V140.026L278.369 104.57V293.666L203.185 326.167Z",
    fill: "#FFDC53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.169 326.672V140.107L141.703 104.57V294.097L204.169 326.672Z",
    fill: "#FCBF1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.64 326.167V140.026L278.369 104.57V293.666L345.64 326.167Z",
    fill: "#FCBF1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 261.22,
    y: 196.797,
    width: 27.9508,
    height: 53.6714,
    fill: "#FFDE86"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250.984,
    y: 173.118,
    width: 27.9508,
    height: 53.6715,
    fill: "#FF997A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 179.036,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 179.037,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 179.037,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 267.912,
    y: 179.037,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 179.037,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 185.748,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 185.748,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 185.748,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 267.912,
    y: 185.748,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 185.748,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 192.458,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 192.458,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 192.458,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 267.912,
    y: 192.458,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 192.458,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 199.162,
    width: 1.96837,
    height: 3.55174,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 199.162,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 199.162,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 267.912,
    y: 199.162,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 199.162,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 205.874,
    width: 1.96837,
    height: 3.55188,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 205.874,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 205.874,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 267.913,
    y: 205.874,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 205.874,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 253.74,
    y: 212.584,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 258.464,
    y: 212.583,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 263.188,
    y: 212.583,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 267.912,
    y: 212.583,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 272.637,
    y: 212.583,
    width: 1.96837,
    height: 3.55181,
    rx: 0.393673,
    fill: "#DE7150"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.935 215.74V173.118",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251.22 226.243V205.877",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.999,
    cy: 192.001,
    rx: 12.5385,
    ry: 12.5694,
    fill: "#F7B500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 206,
    y: 179,
    width: 26,
    height: 26
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.999,
    cy: 192.001,
    rx: 12.5385,
    ry: 12.5694,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.443 180.817H225.199",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.098 181.92H226.853",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.369 183.163H225.889",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.471 184.544L225.889 184.406",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.298 185.925L225.889 185.856",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.125 187.861L226.716 187.792C226.716 187.792 229.259 188.828 229.472 191.314C229.684 193.801 231.326 193.99 231.538 192.652C231.75 191.314 231.125 187.861 231.125 187.861Z",
    fill: "#FFD634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.964 179.985L223.409 180.122",
    stroke: "#FFDC53",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.07,
    cy: 192.001,
    rx: 12.5385,
    ry: 12.5694,
    fill: "#FCA81E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.865 267.836C158.865 267.836 216.664 186.31 229.21 189.84C241.755 193.37 244.231 207.015 256.601 202.63C268.971 198.245 276.999 217.385 287.006 228.849C297.013 240.312 310.036 268.004 310.036 268.004L158.865 267.836Z",
    fill: "#120136"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.018 207.069C264.249 200.372 257.843 202.321 257.843 202.321C257.843 202.321 246.851 205.398 240.355 209.047",
    stroke: "white",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.504 266.732H174.436C174.436 266.732 168.757 258.415 175.945 255.864C183.133 253.314 178.359 247.882 182.382 244.913C186.405 241.943 193.651 244.324 195.117 242.153C196.582 239.983 194.115 235.202 200.504 236.829C206.894 238.455 200.504 266.732 200.504 266.732Z",
    fill: "#1E1548"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.727 244.815C273.727 244.815 279.009 250.83 280.87 255.865C282.732 260.899 282.473 256.75 287.006 258.825C291.54 260.899 286.751 265.169 290.294 264.152C293.837 263.136 294.83 266.733 294.83 266.733H273.65L273.727 244.815Z",
    fill: "#40BAD5"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 184.061,
    y: 234.285,
    width: 1.57472,
    height: 36.7018,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.297 247.705C181.778 247.444 170.882 232.116 176.881 229.071C182.88 226.025 181.583 217.639 184.848 218.366C188.113 219.093 191.387 223.744 191.368 226.789C191.348 229.834 193.43 229.247 193.43 233.43C193.43 237.613 186.815 247.965 184.297 247.705Z",
    fill: "#40BAD5"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 172.25,
    y: 230.339,
    width: 1.57468,
    height: 36.7018,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.486 243.758C169.967 243.497 165.003 239.417 167.497 235.865C169.991 232.313 159.071 228.169 165.07 225.124C171.069 222.079 165.104 214.417 171.069 215.275C177.033 216.133 177.072 219.033 177.052 222.079C177.033 225.124 181.619 225.3 181.619 229.483C181.619 233.666 177.033 233.313 177.033 236.852C177.033 240.39 175.004 244.019 172.486 243.758Z",
    fill: "#FF997A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.824 243.758C173.824 243.758 179.36 239.072 175.934 231.616",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.033 235.863C177.033 235.863 177.834 233.913 179.707 233.013C181.58 232.114 181.899 231.135 181.58 228.845C181.262 226.556 180.253 226.045 178.589 224.977",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.505 266.76V227.382L273.651 206.666V266.76H200.505Z",
    fill: "white",
    stroke: "#1E1548",
    strokeWidth: 0.989271
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_312_543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 206,
    width: 75,
    height: 62
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.505 266.76V227.382L273.651 206.666V266.76H200.505Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.989271
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_312_543)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.207,
    y: 226.986,
    width: 18.5026,
    height: 41.8322,
    rx: 1.57469,
    fill: "#1E1548"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.42,
    y: 226.986,
    width: 18.5027,
    height: 41.8322,
    rx: 1.57469,
    fill: "#FF997A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.591,
    y: 227.974,
    width: 24.0141,
    height: 8.68218,
    rx: 0.787347,
    fill: "#1E1548",
    stroke: "#1E1548",
    strokeWidth: 0.989271
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.689 227.972V236.654",
    stroke: "white",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.485 232.311H231.499",
    stroke: "white",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.769,
    y: 227.975,
    width: 12.2039,
    height: 17.3644,
    rx: 0.787347,
    fill: "#1E1548",
    stroke: "white",
    strokeWidth: 0.989271
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.659 227.97L264.962 245.338",
    stroke: "white",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.056 232.312H270.866",
    stroke: "white",
    strokeWidth: 0.989271,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.272,
    cy: 245.145,
    rx: 0.984185,
    ry: 1.38126,
    fill: "#1E1548"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 86.2287,
    height: 1.97289,
    rx: 0.393673,
    transform: "matrix(0.965766 -0.259414 0.258226 0.966085 195.117 227.154)",
    fill: "#FCBF1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M200.433 256.694V227.975",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.247 229.938L251.124 214.554",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.192 256.391H193.05C192.971 256.391 192.932 256.51 192.932 256.668V256.944H184.035V256.668C184.035 256.51 183.956 256.391 183.917 256.391H182.775C182.696 256.391 182.657 256.51 182.657 256.668V256.944H173.721V256.668C173.721 256.51 173.642 256.391 173.602 256.391H172.461C172.382 256.391 172.343 256.51 172.343 256.668V256.944H163.17V256.668C163.17 256.51 163.131 256.391 163.052 256.391H161.871C161.832 256.391 161.753 256.51 161.753 256.668V266.415C161.753 266.573 161.832 266.692 161.871 266.692H163.013C163.091 266.692 163.131 266.573 163.131 266.415V264.679H172.225V266.376C172.225 266.534 172.303 266.652 172.343 266.652H173.484C173.563 266.652 173.602 266.534 173.602 266.376V264.679H182.46V266.376C182.46 266.534 182.539 266.652 182.578 266.652H183.72C183.799 266.652 183.838 266.534 183.838 266.376V264.679H192.696V266.376C192.696 266.534 192.774 266.652 192.814 266.652H193.955C194.034 266.652 194.074 266.534 194.074 266.376V264.521V263.377V261.364V260.219V258.246V257.062V256.668C194.349 256.51 194.27 256.391 194.192 256.391ZM192.893 258.361V260.097H184.035V258.361H192.893ZM182.578 260.097V258.361H173.721V260.097H182.578ZM172.303 258.361V260.097H163.17V258.361H172.303ZM163.17 261.518V263.254H172.264V261.518H163.17ZM173.721 263.254V261.518H182.578V263.254H173.721ZM184.035 261.518V263.254H192.893V261.518H184.035Z",
    fill: "#C5D4EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.174 256.816H305.032C304.954 256.816 304.914 256.935 304.914 257.093V257.369H296.017V257.093C296.017 256.935 295.939 256.816 295.899 256.816H294.758C294.679 256.816 294.639 256.935 294.639 257.093V257.369H285.703V257.093C285.703 256.935 285.624 256.816 285.585 256.816H284.443C284.365 256.816 284.325 256.935 284.325 257.093V257.369H275.153V257.093C275.153 256.935 275.113 256.816 275.034 256.816H273.853C273.814 256.816 273.735 256.935 273.735 257.093V266.84C273.735 266.998 273.814 267.116 273.853 267.116H274.995C275.074 267.116 275.113 266.998 275.113 266.84V265.104H284.207V266.801C284.207 266.959 284.286 267.077 284.325 267.077H285.467C285.546 267.077 285.585 266.959 285.585 266.801V265.104H294.443V266.801C294.443 266.959 294.521 267.077 294.561 267.077H295.702C295.781 267.077 295.82 266.959 295.82 266.801V265.104H304.678V266.801C304.678 266.959 304.757 267.077 304.796 267.077H305.938C306.017 267.077 306.056 266.959 306.056 266.801V264.946V263.801V261.789V260.644V258.671V257.487V257.093C306.332 256.935 306.253 256.816 306.174 256.816ZM304.875 258.787V260.524H296.017V258.787H304.875ZM294.561 260.524V258.787H285.703V260.524H294.561ZM284.286 258.787V260.524H275.153V258.787H284.286ZM275.153 261.947V263.683H284.246V261.947H275.153ZM285.703 263.683V261.947H294.561V263.683H285.703ZM296.017 261.947V263.683H304.875V261.947H296.017Z",
    fill: "#C5D4EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M256.234 212.955L269.431 209.624",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.927 260.098C260.927 260.098 260.457 249.864 263.87 253.126C267.283 256.388 262.949 266.757 262.949 266.757L261.464 266.689",
    fill: "#1E1548"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260.927 260.098C260.927 260.098 260.457 249.864 263.87 253.126C267.283 256.388 262.949 266.757 262.949 266.757L261.464 266.689",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.619 266.689C258.843 264.052 256.354 259.241 258.909 258.362C261.463 257.482 261.463 266.689 261.463 266.689",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M259.619 266.689C258.843 264.052 256.354 259.241 258.909 258.362C261.463 257.482 261.463 266.689 261.463 266.689",
    stroke: "#1E1548",
    strokeWidth: 0.989271
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M257.676 266.686C257.676 266.686 257.676 264.371 256.351 264.174",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M209.124 266.732C209.124 266.732 209.415 264.122 211.092 263.253",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M207.993 266.692C207.993 266.692 207.342 256.495 212.066 254.418",
    stroke: "#1E1548",
    strokeWidth: 0.989271,
    strokeLinecap: "round"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 202.093,
    y: 258.978,
    width: 2.99192,
    height: 69.7334,
    fill: "#1E1548"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.541 282.684C197.756 282.189 177.053 253.065 188.451 247.279C199.849 241.493 197.385 225.558 203.589 226.94C209.792 228.322 216.014 237.157 215.976 242.943C215.939 248.729 219.894 247.614 219.894 255.562C219.894 263.509 207.327 283.179 202.541 282.684Z",
    fill: "#40BAD5"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 305.046,
    y: 250.005,
    width: 2.5195,
    height: 58.7229,
    fill: "#1E1548"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.423 263.934C301.394 263.517 293.451 256.988 297.442 251.305C301.432 245.622 283.959 238.992 293.558 234.119C303.156 229.247 293.613 216.988 303.156 218.361C312.699 219.734 312.761 224.375 312.73 229.247C312.699 234.119 320.037 234.402 320.037 241.094C320.037 247.787 312.699 247.222 312.699 252.884C312.699 258.545 309.453 264.351 305.423 263.934Z",
    fill: "#FF997A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307.564 263.936C307.564 263.936 316.422 256.438 310.94 244.51",
    stroke: "#1E1548",
    strokeWidth: 1.42455,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M312.698 251.309C312.698 251.309 313.98 248.187 316.977 246.749C319.973 245.31 320.483 243.743 319.973 240.08C319.464 236.417 317.851 235.599 315.188 233.891",
    stroke: "#1E1548",
    strokeWidth: 1.42455,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.075 156.736C293.9 159.33 291.931 151.252 297.64 152.551C303.348 153.85 302.364 160.706 307.088 160.706C311.812 160.706 318.111 164.31 318.111 164.31H272.346C272.346 164.31 280.25 154.141 287.075 156.736Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.938 132.937C226.938 132.937 230.393 129.892 232.322 130.907C234.251 131.922 241.11 126.809 243.173 132.937C233.011 132.937 226.938 132.937 226.938 132.937Z",
    fill: "#FFFDFD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.678 187.942C157.678 187.942 168.374 177.83 173.794 179.851C182.258 183.009 185.803 178.066 189.549 179.851C191.691 180.872 194.261 186.274 199.701 183.581C202.808 182.042 205.963 183.83 203.957 188.208C211.503 187.942 157.678 187.942 157.678 187.942Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.641 233.978C142.641 233.978 150.927 229.262 155.646 247.414C160.366 265.566 158.533 249.145 166.7 253.203C174.866 257.262 166.239 265.614 172.621 263.625C179.004 261.636 180.792 268.673 180.792 268.673H142.641V233.978Z",
    fill: "#92C281"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.667 293.477C345.667 293.477 353.953 288.761 358.673 306.913C363.392 325.065 361.559 308.644 369.726 312.703C377.893 316.761 369.265 325.113 375.648 323.124C382.03 321.135 383.818 328.172 383.818 328.172H345.667V293.477Z",
    fill: "#92C281"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.641 233.974C142.641 233.974 135.499 237.561 132.146 247.41C128.792 257.259 129.259 249.141 121.092 253.2C112.926 257.259 121.553 265.61 115.171 263.621C108.788 261.632 107 268.669 107 268.669H145.151L142.641 233.974Z",
    fill: "#92C281"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.116,
    cy: 278.447,
    r: 26.0419,
    transform: "rotate(-34.7654 401.116 278.447)",
    fill: "#FFDC53"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.479 281.475L403.481 289.489C403.481 290.362 402.076 291.292 401.204 291.292C400.331 291.292 399.044 290.361 399.044 289.488L399.043 281.474L391.029 281.473C390.156 281.473 389.16 279.903 389.16 279.03C389.16 278.158 390.156 277.037 391.028 277.037L399.042 277.038L399.041 267.7C399.04 266.828 400.327 266.144 401.2 266.144C402.072 266.145 403.477 266.828 403.477 267.701L403.479 277.039L411.492 277.04C412.365 277.04 413.182 278.162 413.182 279.034C413.182 279.907 412.366 281.477 411.493 281.476L403.479 281.475Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 376.005,
    cy: 196.815,
    r: 7.01129,
    transform: "rotate(-34.7654 376.005 196.815)",
    fill: "#C1D4ED"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.023,
    cy: 252.593,
    r: 5.00806,
    transform: "rotate(-34.7654 367.023 252.593)",
    fill: "#FF8A7A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.047,
    cy: 312.883,
    r: 3.00484,
    transform: "rotate(-34.7654 382.047 312.883)",
    fill: "#120136"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.186,
    cy: 220.436,
    r: 3.00484,
    transform: "rotate(-34.7654 407.186 220.436)",
    fill: "#40BAD5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.017,
    cy: 127.703,
    r: 34.7033,
    fill: "#40BAD5"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.949 139.718C145.027 142.304 143.928 143.663 143.182 143.663C141.996 143.663 139.975 140.288 139.052 133.932H144.543L144.456 133.625C144.236 132.661 144.324 131.696 144.719 130.819H138.745C138.657 129.592 138.613 128.277 138.613 126.874C138.613 125.471 138.657 124.156 138.745 122.973H147.662C147.75 124.2 147.794 125.515 147.794 126.874C147.794 127.313 147.794 127.751 147.794 128.189C148.146 128.102 148.497 128.058 148.848 128.058C149.2 128.058 149.551 128.102 149.903 128.189L150.913 128.452C150.957 127.926 150.957 127.4 150.957 126.874C150.957 125.559 150.913 124.244 150.825 122.973H159.567C159.874 124.2 160.05 125.515 160.05 126.874C160.05 128.102 159.874 129.329 159.611 130.513L162.51 131.214C162.598 131.214 162.686 131.258 162.73 131.302C163.037 129.899 163.213 128.408 163.213 126.874C163.213 115.828 154.208 106.885 143.182 106.885C132.156 106.885 123.194 115.828 123.194 126.874C123.194 137.921 132.2 146.863 143.226 146.863C144.719 146.863 146.213 146.688 147.618 146.381C147.618 146.337 147.574 146.293 147.574 146.206L145.949 139.718ZM158.469 119.773H150.518C150.034 116.222 149.2 113.066 147.97 110.699C152.626 112.102 156.448 115.433 158.469 119.773ZM143.182 110.041C144.368 110.041 146.388 113.417 147.311 119.773H139.096C139.975 113.417 141.996 110.041 143.182 110.041ZM126.357 126.874C126.357 125.515 126.533 124.2 126.84 122.973H135.582C135.494 124.244 135.406 125.559 135.406 126.874C135.406 128.189 135.45 129.504 135.582 130.819H126.796C126.533 129.548 126.357 128.233 126.357 126.874ZM127.939 133.976H135.89C136.373 137.482 137.207 140.682 138.437 143.006C133.781 141.603 129.959 138.272 127.939 133.976ZM135.89 119.773H127.939C129.959 115.433 133.781 112.102 138.437 110.743C137.251 113.066 136.373 116.266 135.89 119.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.618 144.495L158.6 138.533L162.026 136.78C163.125 136.21 162.949 134.588 161.719 134.281L149.112 131.256C148.145 131.037 147.267 131.914 147.486 132.878L150.605 145.459C150.913 146.687 152.538 146.862 153.109 145.766L154.866 142.347L160.84 148.308C161.148 148.615 161.675 148.615 162.026 148.308L164.662 145.678C164.926 145.371 164.926 144.845 164.618 144.495Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6439,
    height: 41.6439,
    fill: "white",
    transform: "translate(123.194 106.883)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseNohandHomepage);
export default __webpack_public_path__ + "static/media/house-nohand-homepage.01f38612.svg";
export { ForwardRef as ReactComponent };